/* =============================================
   Product Manual & Video — product-manual-video.js
   ============================================= */

(function () {
  'use strict';

  function initTagFilter(section) {
    var tags = section.querySelectorAll('.pmv-tag');
    var blocks = section.querySelectorAll('.pmv-block');

    function applyFilter(tag) {
      blocks.forEach(function (block) {
        if (tag === 'all' || block.dataset.tag === tag) {
          block.classList.remove('pmv-block--hidden');
        } else {
          block.classList.add('pmv-block--hidden');
        }
      });
    }

    tags.forEach(function (btn) {
      btn.addEventListener('click', function () {
        tags.forEach(function (b) {
          b.classList.remove('pmv-tag--active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('pmv-tag--active');
        btn.setAttribute('aria-selected', 'true');
        applyFilter(btn.dataset.tag);
      });
    });

    applyFilter('all');
  }

  function init() {
    document.querySelectorAll('.pmv-section').forEach(function (section) {
      initTagFilter(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', init);
  }

})();